var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedCircleWhiteExclamation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C8.954 40 0 31.046 0 20C0 8.954 8.954 0 20 0C31.046 0 40 8.954 40 20C40 31.046 31.046 40 20 40ZM18.5 26C18.2239 26 18 26.2239 18 26.5V29.5C18 29.7761 18.2239 30 18.5 30H21.5C21.7761 30 22 29.7761 22 29.5V26.5C22 26.2239 21.7761 26 21.5 26H18.5ZM18.5 10C18.2239 10 18 10.2239 18 10.5V21.5C18 21.7761 18.2239 22 18.5 22H21.5C21.7761 22 22 21.7761 22 21.5V10.5C22 10.2239 21.7761 10 21.5 10H18.5Z",
    fill: "#E63559"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedCircleWhiteExclamation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redCircleWhiteExclamation.aec79ab1.svg";
export { ForwardRef as ReactComponent };